/// <reference path="../../types/web/third_party/atmosphere.d.ts" />

namespace BSMsg {
	export interface Message {
		channels: string[];
		data: string;
		permissions?: string[];
		organization?: string;
		crossOrganization?: boolean;
		uuid?: string;
		timestamp?: number;
	}

	export interface ListenData {
		channels: string[];
		onMessage: (msg: Message) => void;
		//no longer supported
		//crossOrganization?: boolean;
	}

	export interface ListenerCloser {
		close: () => void;
	}

	interface DupCheckData {
		uuid: string;
		time: number
	}

	interface ChannelUpdates {
		refreshChannels?: string[];
	}

	type SendData = Message | ChannelUpdates; 

	export class BSMsg {
		private request = new atmosphere.AtmosphereRequest!();
		private channels = new Set<string>();

		private isSubscribed = false;
		private socket: Atmosphere.Request | undefined;
		private listeners: ListenData[] = [];
		private isConnected = false;
		private preConnectMessages: SendData[] = [];
		private timeout: number;

		constructor() {
			this.request.contentType = "application/json";
			this.request.transport = 'websocket';
			this.request.shared = true;
			this.request.onMessage = (response: Atmosphere.Response) => {
				const messageStr = response.responseBody!;
				const message: Message = JSON.parse(messageStr);
				this.listeners.forEach(l => {
					if (l.channels.some(s => message.channels.includes(s))) {
						l.onMessage(message);
					}
				});
			};
			this.request.onOpen = (response?: Atmosphere.Response) => {
				this.isConnected = true;
				this.socket = response!.request;
				this.preConnectMessages.forEach(sendData => this.socket!.push!(JSON.stringify(sendData)));
				this.preConnectMessages = [];
			}
			this.request.onClose = (response?: Atmosphere.Response) => {
				this.isConnected = false;
			}
		}

		public send(sendData: Message) {
			this.sendData(sendData);
		}

		private sendData(sendData: SendData) {
			this.openIfNotSubscribed();
			if (this.isConnected) {
				this.socket!.push!(JSON.stringify(sendData));
			} else {
				this.preConnectMessages.push(sendData);
			}
		}

		public sendLocal(sendData: Message) {
			this.socket!.pushLocal!(JSON.stringify(sendData));
		}

		public listen(listenData: ListenData): ListenerCloser {
			this.openIfNotSubscribed();
			this.addChannels(listenData.channels);
			this.listeners.push(listenData);
			return { close: () => this.removeListenData(listenData) };
		}

		public closeListener(listenerCloser: ListenerCloser) {
			listenerCloser.close();
		}

		private removeListenData(listenData: ListenData) {
			const index = this.listeners.indexOf(listenData);
			if (index > -1) {
				this.listeners.splice(index, 1);
				if (this.listeners.length === 0) {
					this.closeIfSubsribed();
				} else {
					const newChannels = new Set<string>();
					this.listeners.forEach(l => l.channels.forEach(c => newChannels.add(c)));
					if (newChannels.size !== this.channels.size) {
						this.channels = newChannels;
					}
				}
			}
		}

		private pushChannels() {
			if (this.timeout) {
				clearTimeout(this.timeout);
			}
			// 4 minutes
			this.timeout = setTimeout(() => this.pushChannels(), 240_000);
			this.sendData({ refreshChannels: [...this.channels] });
		}

		private addChannels(channels: string[]) {
			channels.forEach(c => this.channels.add(c));
			this.pushChannels();
		}

		private openIfNotSubscribed() {
			if (!this.isSubscribed) {
				this.request.url = "/a/bsmsg/";
				this.socket = atmosphere.subscribe!(this.request);
				this.isSubscribed = true;
			}
		}

		private closeIfSubsribed() {
			if (this.isSubscribed) {
				this.socket!.close!();
				this.isSubscribed = false;
			}
		}
	}
}

var bsmsg = new BSMsg.BSMsg();

